import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Steps = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <div ref={ref} className="bg-gray-50 py-10 px-5 md:px-20">
      <motion.h2 
        initial={{ opacity: 0, y: -20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
        className="text-center text-2xl md:text-4xl font-bold mb-10"
      >
        Çalışma Sürecimiz
      </motion.h2>
      <motion.p 
        initial={{ opacity: 0, y: -10 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="text-center text-gray-600 mb-10"
      >
        Kocabay Tur çalışma sürecinin adımlarını beraber inceleyelim;
      </motion.p>
      <div className="grid gap-6 md:grid-cols-3">
        {[
          {
            step: 1,
            title: "Bilgi Aşaması",
            description:
              "Bizlere ihtiyacınız olan hizmetimiz ile ilgili bilgi sunuyorsunuz.",
            icon: "💬", 
          },
          {
            step: 2,
            title: "Hizmet Seçimi",
            description:
              "Gerekli değerlendirme ve sözleşme aşamasından sonra hizmeti başlatıyoruz.",
            icon: "📋", 
          },
          {
            step: 3,
            title: "Hizmetiniz Başladı!",
            description:
              "Sözleşme koşullarımız doğrultusunda hizmetinizi başlatıyoruz.",
            icon: "🏷️", 
          },
        ].map(({ step, title, description, icon }, index) => (
          <motion.div
            key={step}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            className="bg-white rounded-2xl shadow-lg p-6 text-center"
          >
            <div className="flex items-center justify-center mb-4">
              <div className="text-xl font-bold text-white bg-[#092049] rounded-full w-12 h-12 flex items-center justify-center">
                {step}
              </div>
            </div>
            <div className="mb-4 text-4xl">{icon}</div>
            <h3 className="text-xl font-semibold mb-2">{title}</h3>
            <p className="text-gray-600 mb-4">{description}</p>
            <a
              href="https://wa.me/905423983273"
              className="text-white bg-[#092049] hover:bg-cyan-600 px-4 py-2 rounded-full inline-block"
            >
              Whatsapp Hattı
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Steps;
